import { z } from 'zod';

/**
 * Contratti letti dalla shell applicativa tenant (sidebar, bottom nav mobile,
 * contesto moduli, profilo personale): piccole risposte di stato che prima il
 * frontend leggeva con `fetch` diretto e `any`.
 *
 *  - `GET /freeswitch/status`  → `data: FreeswitchStatusData`
 *  - `GET /system/esl-health`  → `data: EslHealthData`
 *  - `GET /my-modules`         → TOP-LEVEL `MyModulesResponse`
 *  - `GET /voip/my-profile`    → `data: MyProfile`
 */

export const freeswitchStatusDataSchema = z
  .object({
    connected: z.boolean(),
  })
  .passthrough();
export type FreeswitchStatusData = z.infer<typeof freeswitchStatusDataSchema>;

export const eslHealthDataSchema = z
  .object({
    state: z.string(),
  })
  .passthrough();
export type EslHealthData = z.infer<typeof eslHealthDataSchema>;

export const myModulesResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(z.string()),
  product: z.string().nullable().optional(),
});
export type MyModulesResponse = z.infer<typeof myModulesResponseSchema>;

export const myProfileSchema = z
  .object({
    id: z.string(),
    email: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    role: z.string(),
    status: z.string(),
    avatar_url: z.string().nullable(),
    extension: z
      .object({
        id: z.string(),
        number: z.string(),
        display_name: z.string(),
      })
      .nullable(),
    tenant: z.object({
      name: z.string(),
      slug: z.string(),
    }),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .passthrough();
export type MyProfile = z.infer<typeof myProfileSchema>;
